<template>
  <div class="operations-table-wrapper">
    <v-data-table
      :headers="headers"
      :items="items"
      :header-props="{ sortIcon: 'bhi-menu-down' }"
      :items-per-page="itemsPerPage"
      :hide-default-footer="hideDefaultFooter"
      :server-items-length="serverItemsLength"
      :page="page"
      :footer-props="footerProps"
      mobile-breakpoint="1"
      :disable-pagination="items.length==0"
      class="elevation-0 operations-table"
      @pagination="onPagination"
      @update:sort-desc="onSortDesc"
      @update:sort-by="onSortBy"
    >
      <template v-slot:body="{ items }">
        <tbody>
          <template v-for="log in items">
            <component
              :is="rowComponent"
              :key="log.id"
              :log="log"
              v-bind="$attrs"
              v-on="$listeners"
              @to-log="$emit('to-log', $event)"
            />
            <tr
              class="operations-table-empty"
              :key="`${log.id}-empty`"
            >
              <td class="operations-table-empty">&nbsp;</td>
            </tr>
          </template>
        </tbody>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import OperationsTableRow from '@/components/adminPanelLogs/OperationsTableRow.vue';
import { debounce } from "@/helpers/debounce"

export default {
  name: 'OperationsTable',
  components: { OperationsTableRow },
  props: {
    headers: {
      type: Array,
      default: () => ([])
    },
    items: {
      type: Array,
      default: () => ([])
    },
    rowComponent: {
      type: String,
      default: 'operations-table-row'
    },
    itemsPerPage: {
      type: Number,
      default: 10
    },
    hideDefaultFooter: {
      type: Boolean,
      default: false
    },
    serverItemsLength: {
      type: Number,
      default: -1
    },
    page: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      paramsStore: null,
      footerProps: {'items-per-page-options': [10, 25, 50, 100]},
      init: true
    }
  },
  methods: {
    onSortBy (data) {
      this.paramsHasChanged({ sortBy: !data[0] ? null : data })
    },
    onSortDesc (data) {
      const sortDirection = !data[0] && data[0] !== false
        ? null
        : data.map(item => item ? 'desc': 'asc')
      this.paramsHasChanged({ sortDirection })
    },
    onPagination ({ page, itemsPerPage }) {
      // @todo event on mounted - so far I don't know why this is called - bug in v-data-table?
      if (this.init && ((page === 1 && itemsPerPage === 10) )) {
        return
      }
      this.init = false
      this.paramsHasChanged({ page, pageSize: itemsPerPage })
    },
    paramsHasChanged (data) {
      this.paramsStore = this.paramsStore
        ? { ...this.paramsStore, ...data }
        : data
      debounce(() => {
        this.$emit('action:get-data', { ...this.paramsStore })
        this.paramsStore = null
      }, 100, 'OperationsTable')
    }
  }
}
</script>

<style lang="scss">
  .operations-table-wrapper {
    table {
      border-spacing: 0;
    }
    .operations-table {
      background-color: transparent !important;

      thead > tr {
        border-bottom: 0 !important;
        vertical-align: bottom;
      }

      th {
        white-space: nowrap !important;
        color: $bh-blue !important;
        text-transform: uppercase;
        font-size: 0.715rem !important;
        line-height: 2.4em;
        height: auto !important;
        padding: 0 0.5*$gutter !important;
        border-bottom: 0 !important;
        letter-spacing: 1px;
        font-weight: 700;

        span {
          vertical-align: middle;
          font-weight: 700;
        }

        .v-data-table-header__icon {
          color: $bh-blue--3 !important;
          opacity: 1;
          transform:rotate(-90deg);
          margin-left: 0.25*$gutter;
        }

        &:hover,
        &.sortable.active {
          .v-data-table-header__icon {
            color: $bh-blue !important;
            opacity:1;
          }
        }

        &:hover .v-data-table-header__icon {
        transform:rotate(-90deg);
        }

        &.sortable.active:hover .v-data-table-header__icon {
          transform:rotate(0deg);
        }

        &.sortable.active.desc:hover .v-data-table-header__icon {
          transform:rotate(-180deg);
        }
      }

      table {
        min-width: 960px;
      }

      &-empty {
        background: transparent !important;
        height: 0 !important;
        border-bottom: 0 !important;
        font-size: 0.381rem !important;
      }

      .v-data-footer {
        justify-content: center;
        border-top:0 !important;
        &__select {
          margin-left: 0;
        }
      }
    }
  }
</style>
